import { clientCaseIBusinessPackDownloadSummaryZipApi } from './downloadSummaryZip';

export function clientCaseIBusinessPackApi(path: string) {
  return {
    path,
    downloadSummaryZip: () =>
      clientCaseIBusinessPackDownloadSummaryZipApi(`${path}/download_summary_zip`),
  };
}
